import "./TradingSystemsViewComponent.scss";
import {IComponentOptions, IOnInit} from "angular";
import {Observable} from "rxjs";
import {SecurityTradingSystemIndicators} from "../models/SecurityTradingSystemIndicators";
import {TradingSystemsViewStore} from "../service/TradingSystemsViewStore";
import {SelectedSystemType} from "../models/SelectedSystemType";
import {LittDirection} from "../models/LittDirection";

export const TradingSystemsView = "tradingSystemsView";

export function tradingSystemsView(): IComponentOptions {
    return {
        templateUrl: "app/trading-systems/view/TradingSystemsViewComponent.html",
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: TradingToolsViewComponentController
    };
}

export class TradingToolsViewComponentController implements IOnInit {

    public readonly viewStore: TradingSystemsViewStore;

    public tradingSystems$: Observable<Array<SecurityTradingSystemIndicators>>;

    public $onInit(): void {
        this.tradingSystems$ = this.viewStore.tradingSystems;
    }

    public littSelected(system: SecurityTradingSystemIndicators) {
        switch (system.littDirection) {
            case LittDirection.LONG:
                this.viewStore.select(system, SelectedSystemType.LITT_LONG);
                break;
            case LittDirection.SHORT:
                this.viewStore.select(system, SelectedSystemType.LITT_SHORT);
                break;
        }
    }

    public condorSelected(system: SecurityTradingSystemIndicators) {
        this.viewStore.select(system, SelectedSystemType.IRON_CONDOR);
    }
}
